<template lang="pug">
  div
    Section1Widget(to="/products")
    div(v-if="!$parent.busy && category")
      b-card-img(v-if="category.image_1" :src="assets_base_url + category.image_1")
      b-card.text-left(v-if="!$parent.busy && category")
        b-card-text.h4 {{name}}
        b-card-text {{description}}
        b-card-text
          ul
            li(v-for="cat,idx in subcategories") {{cat.name}}
        div(v-if="brochures.length>0")
          b-card-text.h4.text-primary {{dict.download_brochures}}
          b-card-text
            b-list-group
              b-list-group-item(v-for="brochure,idx in brochures" :key="idx")
                b-link(:href="brochure.download_url" target="_blank") {{brochure.download_caption||brochure.download_url}}
    div(v-else-if="!$parent.busy && !category")
      p.alert-warning Nothing found.
    
</template>
<script>
import Section1Widget from './components/Section1Widget.vue'
export default {
  name: 'ProductDetails',
  components: {
    Section1Widget
  },
  data: function(){
    return {
      assets_base_url: process.env.VUE_APP_ASSETS_URL,
      category: null,
      name: "",
      description: "",
      dict: this.$dictionary.products,
    }
  },
  computed:{
    subcategories: function(){
      if(!this.category) return [];
      //Only subcategories with a valid image...
      return this.$root.categories.reduce((agg,cat)=>{
        if (cat.parent_id == this.category.id){
          if(this.$root.lang.startsWith('zh') ){
            cat.name = cat.name_zh;
          } else {
            cat.name = cat.name_en;
          }
          agg.push(cat);
        }
        return agg;
      },[]);
    },
    brochures: function(){
      if(!this.subcategories) return [];
      return this.subcategories.reduce((agg,cat)=>{
        if(this.$root.lang.startsWith('zh') && cat.download_url_zh){
          cat.download_caption = cat.download_caption_zh;
          cat.download_url =  cat.download_url_zh;
          agg.push(cat);
        } else if ( cat.download_url_en){
          cat.download_caption = cat.download_caption_en;
          cat.download_url =  cat.download_url_en;
          agg.push(cat);
        }
        
        return agg;
      },[]);
    }
  },
  created: async function(){
    this.initView(this.$route.params.category_id);
  },
  watch: {
    $route(to) {
      this.initView(to.params.category_id)
    }
  },
  methods: {
    initView: function(category_id){
      this.category = this.findCategory(category_id);
      if(!this.category){
        this.$router.push("/products");
        return;
      }
      if(this.$root.lang.startsWith('en')){
        this.name = this.category.name_en;
        this.description = this.category.description_en;
      } else {
        this.name = this.category.name_zh;
        this.description = this.category.description_zh;
      }
    },
    findCategory: function(category_id){
      return this.$root.categories.find(c=>{return c.id==category_id;})
    }
  }
}
</script>
